import Layout from '@layout/Index'

export const position = [
  {
    path: '/position',
    component: Layout,
    children: [
      {path: 'table', component: () => import('./pages/PositionTable.vue'), name: '职位列表'},
      {path: 'detail/:id', component: () => import('./pages/PositionDetail.vue'), name: '职位详情'},
      {path: 'upload', component: () => import('./pages/PositionUpload.vue'), name: '批量上传'},
      {path: 'update/:id', component: () => import('./pages/PositionForm.vue'), name: '修改职业详情'},
      {path: 'pending-audit-table', component: () => import('./pages/PositionPendingAuditTable.vue'), name: '待审核职位'},
      {path: 'audit-table', component: () => import('./pages/PositionAuditTable.vue'), name: '已审核职位'},
      {path: 'audit-detail/:id', component: () => import('./pages/PositionAuditDetail.vue'), name: '已审核职位详情'},
      {
        path: 'pending-audit-detail/:id',
        component: () => import('./pages/PositionPendingAuditDetail.vue'),
        name: '待审核职位详情',
        meta: {
          title: '待审核职位详情',
        },
      },
      {path: 'pending-check-detail/:id', component: () => import('./pages/PositionCheckDetail.vue'), name: '职位审核'},
      {path: 'pending-audit-update/:id', component: () => import('./pages/PositionPendingAuditForm.vue'), name: '职位修改'},
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/position/position.route.js